import ComumDataService from "@/services/ComumDataService";
const DataService = ComumDataService;

export const buscaCep = {
  //Pra funcionar tem que adicionar o evento no campo cep e declarar dataservice como uma
  //propriedade de data no componente

  mounted() {
    setTimeout(() => {
      this.getCidades();
    }, 1000);
  },
  data() {
    return {
      cidades: [],
    };
  },
  methods: {
    buscaCep(e) {
      if (e.target.value.length >= 8) {
        console.log("buscaCep");
        DataService.buscaCep(this.limpaMascara(e.target.value)).then(
          async (response) => {
            DataService.findCidade({
              cidade: response.data.localidade,
              uf: response.data.uf,
            }).then((cidade) => {
              console.log("this.recurso", this.recurso);
              if (typeof this.recurso.cidade !== "undefined") {
                console.log("else" + cidade);
                this.recurso.cidade = cidade.data;
                this.recurso.logradouro = response.data.logradouro;
                this.recurso.bairro = response.data.bairro;
              } else if (typeof this.recurso.pessoa !== "undefined") {
                this.recurso.pessoa.cidade = cidade.data;
                this.recurso.pessoa.logradouro = response.data.logradouro;
                this.recurso.pessoa.bairro = response.data.bairro;
              }
            });
          }
        );
      }
    },

    getCidades() {
      DataService.getCidades()
        .then((response) => {
          this.cidades = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
